import React from 'react';
import { Flex, theme, Typography } from 'antd';

const { Text } = Typography;

const getName = (key: string, prop: string, component, variables?) => {
	const [dataSource, , propertyName] = key.split('.');
	switch (prop) {
		case 'name':
			return propertyName;
		case 'dataSource':
			return dataSource;
		case 'recordType':
			const variable = variables.find(v => v.id === component.variableId);
			return `${dataSource}.${variable.entity}`;
		default:
			return key;
	}
};

export const SystemFilledFieldsEditor = ({ component, variables }) => {
	const { token } = theme.useToken();
	const systemFilledAttributes = [
		{
			label: 'Label',
			value: getName(component?.name, 'name', component),
		},
		{
			label: 'Data source',
			value: getName(component?.name, 'dataSource', component),
		},
		{
			label: 'Record type',
			value: getName(component?.name, 'recordType', component, variables),
		},
	];

	return (
		<Flex style={{ maxWidth: 280 }} vertical>
			{systemFilledAttributes.map(({ label, value }) => (
				<Flex
					key={label}
					vertical
					gap={token.marginXS}
					style={{ margin: token.marginXS }}
				>
					<Text type="secondary">{label}</Text>
					<Text>{value}</Text>
				</Flex>
			))}
		</Flex>
	);
};
